module.exports = __webpack_public_path__ + "static/img/band-2.44ed67e3.png";